import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {BoosterKind} from "@/modules/redactor/models/booster/BoosterKind";
import {TriggerUtils} from "@/modules/redactor/models/trigger/core/TriggerUtils";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {ProductModel} from "@/modules/redactor/models/product/ProductModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class BoosterModel extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._kind = false;
        this._priority = 0;
        this._idleTime = 0;

        this._currency = null;
        this._products = [];
        this._itemsAllowed = [];

        this._triggersAvailable = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get priority() {
        return this._priority;
    }

    set priority(value) {
        this._priority = value;
    }

    get idleTime() {
        return this._idleTime;
    }

    set idleTime(value) {
        this._idleTime = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }

    get itemsAllowed() {
        return this._itemsAllowed;
    }

    set itemsAllowed(value) {
        this._itemsAllowed = value;
    }

    get triggersAvailable() {
        return this._triggersAvailable;
    }

    set triggersAvailable(value) {
        this._triggersAvailable = value;
    }

    valid() {

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (!this.kind || BoosterKind.isNone(this.kind)) {
            return false;
        }

        if (!Number.isInteger(this.idleTime) || this.idleTime < 0) {
            return false;
        }

        if (!this.currency || !CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (!this.products || this.products.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.itemsAllowed && this.itemsAllowed.some(v => !RedactorUtils.getItems().some(item => item.key?.equal(v)))) {
            console.log('Invalid config: Missing Item for one of allowed items');
            return false;
        }

        if (this.triggersAvailable.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._id = "";
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new BoosterModel());
        } else if (target instanceof BoosterModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(BoosterModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _kind: alias("kind", BoosterKind.schema()),
    _priority: alias("priority", Schema.primitive()),
    _idleTime: alias("idle_time", Schema.primitive()),
    _currency: alias("currency", CurrencyKindModel.schema()),
    _products: alias("products", list(ProductModel.schema())),
    _itemsAllowed: alias("items_allowed", list(ItemKey.schema())),
    _triggersAvailable: alias("triggers_available", TriggerUtils.schema()),
});